import { default as eraserjkQcaPlhpSMeta } from "/var/www/html/pages/eraser.vue?macro=true";
import { default as _91_91id_93_93DwprhMnxvLMeta } from "/var/www/html/pages/file/[[id]].vue?macro=true";
import { default as filesQPG8Jxg1c0Meta } from "/var/www/html/pages/files.vue?macro=true";
import { default as generatingAJEWduGSPgMeta } from "/var/www/html/pages/generating.vue?macro=true";
import { default as iframe5uEyrd5TPzMeta } from "/var/www/html/pages/iframe.vue?macro=true";
import { default as indexUbNeHw0dYYMeta } from "/var/www/html/pages/index.vue?macro=true";
import { default as oauth5kIXbcO8E1Meta } from "/var/www/html/pages/oauth.vue?macro=true";
import { default as payment_45failAyhOH7iOs6Meta } from "/var/www/html/pages/payment-fail.vue?macro=true";
import { default as payment_45successA3XfyAVHCDMeta } from "/var/www/html/pages/payment-success.vue?macro=true";
import { default as paymentAk5cclthOjMeta } from "/var/www/html/pages/payment.vue?macro=true";
import { default as pricingpIbQutn3yiMeta } from "/var/www/html/pages/pricing.vue?macro=true";
import { default as templatespKk1GRzemFMeta } from "/var/www/html/pages/templates.vue?macro=true";
import { default as userswftYshSOqUMeta } from "/var/www/html/pages/users.vue?macro=true";
export default [
  {
    name: eraserjkQcaPlhpSMeta?.name ?? "eraser",
    path: eraserjkQcaPlhpSMeta?.path ?? "/eraser",
    meta: eraserjkQcaPlhpSMeta || {},
    alias: eraserjkQcaPlhpSMeta?.alias || [],
    redirect: eraserjkQcaPlhpSMeta?.redirect || undefined,
    component: () => import("/var/www/html/pages/eraser.vue").then(m => m.default || m)
  },
  {
    name: _91_91id_93_93DwprhMnxvLMeta?.name ?? "file-id",
    path: _91_91id_93_93DwprhMnxvLMeta?.path ?? "/file/:id?",
    meta: _91_91id_93_93DwprhMnxvLMeta || {},
    alias: _91_91id_93_93DwprhMnxvLMeta?.alias || [],
    redirect: _91_91id_93_93DwprhMnxvLMeta?.redirect || undefined,
    component: () => import("/var/www/html/pages/file/[[id]].vue").then(m => m.default || m)
  },
  {
    name: filesQPG8Jxg1c0Meta?.name ?? "files",
    path: filesQPG8Jxg1c0Meta?.path ?? "/files",
    meta: filesQPG8Jxg1c0Meta || {},
    alias: filesQPG8Jxg1c0Meta?.alias || [],
    redirect: filesQPG8Jxg1c0Meta?.redirect || undefined,
    component: () => import("/var/www/html/pages/files.vue").then(m => m.default || m)
  },
  {
    name: generatingAJEWduGSPgMeta?.name ?? "generating",
    path: generatingAJEWduGSPgMeta?.path ?? "/generating",
    meta: generatingAJEWduGSPgMeta || {},
    alias: generatingAJEWduGSPgMeta?.alias || [],
    redirect: generatingAJEWduGSPgMeta?.redirect || undefined,
    component: () => import("/var/www/html/pages/generating.vue").then(m => m.default || m)
  },
  {
    name: iframe5uEyrd5TPzMeta?.name ?? "iframe",
    path: iframe5uEyrd5TPzMeta?.path ?? "/iframe",
    meta: iframe5uEyrd5TPzMeta || {},
    alias: iframe5uEyrd5TPzMeta?.alias || [],
    redirect: iframe5uEyrd5TPzMeta?.redirect || undefined,
    component: () => import("/var/www/html/pages/iframe.vue").then(m => m.default || m)
  },
  {
    name: indexUbNeHw0dYYMeta?.name ?? "index",
    path: indexUbNeHw0dYYMeta?.path ?? "/",
    meta: indexUbNeHw0dYYMeta || {},
    alias: indexUbNeHw0dYYMeta?.alias || [],
    redirect: indexUbNeHw0dYYMeta?.redirect || undefined,
    component: () => import("/var/www/html/pages/index.vue").then(m => m.default || m)
  },
  {
    name: oauth5kIXbcO8E1Meta?.name ?? "oauth",
    path: oauth5kIXbcO8E1Meta?.path ?? "/oauth",
    meta: oauth5kIXbcO8E1Meta || {},
    alias: oauth5kIXbcO8E1Meta?.alias || [],
    redirect: oauth5kIXbcO8E1Meta?.redirect || undefined,
    component: () => import("/var/www/html/pages/oauth.vue").then(m => m.default || m)
  },
  {
    name: payment_45failAyhOH7iOs6Meta?.name ?? "payment-fail",
    path: payment_45failAyhOH7iOs6Meta?.path ?? "/payment-fail",
    meta: payment_45failAyhOH7iOs6Meta || {},
    alias: payment_45failAyhOH7iOs6Meta?.alias || [],
    redirect: payment_45failAyhOH7iOs6Meta?.redirect || undefined,
    component: () => import("/var/www/html/pages/payment-fail.vue").then(m => m.default || m)
  },
  {
    name: payment_45successA3XfyAVHCDMeta?.name ?? "payment-success",
    path: payment_45successA3XfyAVHCDMeta?.path ?? "/payment-success",
    meta: payment_45successA3XfyAVHCDMeta || {},
    alias: payment_45successA3XfyAVHCDMeta?.alias || [],
    redirect: payment_45successA3XfyAVHCDMeta?.redirect || undefined,
    component: () => import("/var/www/html/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: paymentAk5cclthOjMeta?.name ?? "payment",
    path: paymentAk5cclthOjMeta?.path ?? "/payment",
    meta: paymentAk5cclthOjMeta || {},
    alias: paymentAk5cclthOjMeta?.alias || [],
    redirect: paymentAk5cclthOjMeta?.redirect || undefined,
    component: () => import("/var/www/html/pages/payment.vue").then(m => m.default || m)
  },
  {
    name: pricingpIbQutn3yiMeta?.name ?? "pricing",
    path: pricingpIbQutn3yiMeta?.path ?? "/pricing",
    meta: pricingpIbQutn3yiMeta || {},
    alias: pricingpIbQutn3yiMeta?.alias || [],
    redirect: pricingpIbQutn3yiMeta?.redirect || undefined,
    component: () => import("/var/www/html/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: templatespKk1GRzemFMeta?.name ?? "templates",
    path: templatespKk1GRzemFMeta?.path ?? "/templates",
    meta: templatespKk1GRzemFMeta || {},
    alias: templatespKk1GRzemFMeta?.alias || [],
    redirect: templatespKk1GRzemFMeta?.redirect || undefined,
    component: () => import("/var/www/html/pages/templates.vue").then(m => m.default || m)
  },
  {
    name: userswftYshSOqUMeta?.name ?? "users",
    path: userswftYshSOqUMeta?.path ?? "/users",
    meta: userswftYshSOqUMeta || {},
    alias: userswftYshSOqUMeta?.alias || [],
    redirect: userswftYshSOqUMeta?.redirect || undefined,
    component: () => import("/var/www/html/pages/users.vue").then(m => m.default || m)
  }
]